module.exports = __webpack_public_path__ + "img/camera-video.a04e2dc4.svg";